// Scholavia Practice Questions — NOT official IELTS/TOEFL/scholarship questions.
// Original practice content authored for diagnostic purposes only.
export const testCategories = [
  {
    id: "english",
    label: "English Test",
    desc: "Reading, Listening, Grammar, Vocabulary, Writing",
    sections: ["Reading", "Listening", "Grammar", "Vocabulary", "Writing"],
  },
  {
    id: "academic",
    label: "Academic Test",
    desc: "Logical & Quantitative Reasoning, Comprehension",
    sections: ["Logical Reasoning", "Quantitative Reasoning", "Academic Knowledge", "Reading Comprehension"],
  },
  {
    id: "scholarship",
    label: "Scholarship Specific",
    desc: "Motivation, Leadership, Study Goals, Situational Judgement",
    sections: ["Motivation", "Leadership", "Study Goals", "Situational Judgement"],
  },
];

export const questionBank = {
  english: [
    {
      id: "e1", section: "Grammar",
      q: "The government is committed to ______ sustainable development through green energy policies.",
      options: ["promoting", "to promote", "promotes", "promoted"], answer: 0,
    },
    {
      id: "e2", section: "Vocabulary",
      q: "Choose the word closest in meaning to 'meticulous'.",
      options: ["careless", "thorough", "quick", "generous"], answer: 1,
    },
    {
      id: "e3", section: "Reading",
      q: "A passage states research funding 'may be extended'. This most likely means the extension is:",
      options: ["guaranteed", "impossible", "conditional / not certain", "already completed"], answer: 2,
    },
    {
      id: "e4", section: "Grammar",
      q: "By the time the results were announced, she ______ for three years.",
      options: ["studies", "had been studying", "study", "is studying"], answer: 1,
    },
    {
      id: "e5", section: "Vocabulary",
      q: "'Concise' most nearly means:",
      options: ["brief and clear", "confusing", "lengthy", "loud"], answer: 0,
    },
    {
      id: "e6", section: "Reading",
      q: "In an academic abstract, the 'methodology' section describes:",
      options: ["the results", "how the study was conducted", "future work", "the references"], answer: 1,
    },
    {
      id: "e7", section: "Writing",
      q: "Which sentence is most appropriate for a formal motivation letter?",
      options: ["I really really wanna study here!", "I am eager to contribute to and learn from this program.", "Gimme the scholarship pls.", "This place looks cool."], answer: 1,
    },
    {
      id: "e8", section: "Grammar",
      q: "Neither the students nor the lecturer ______ ready for the change.",
      options: ["were", "was", "are", "be"], answer: 1,
    },
    {
      id: "e9", section: "Vocabulary",
      q: "A 'prerequisite' is something that is:",
      options: ["optional", "required beforehand", "forbidden", "irrelevant"], answer: 1,
    },
    {
      id: "e10", section: "Reading",
      q: "'The findings are inconclusive.' This means the findings are:",
      options: ["very strong", "not definitive", "false", "official"], answer: 1,
    },
  ],
  academic: [
    {
      id: "a1", section: "Logical Reasoning",
      q: "All scholars read widely. Some readers write papers. Which must be true?",
      options: ["All scholars write papers", "Some scholars may write papers", "No scholar writes papers", "All writers are scholars"], answer: 1,
    },
    {
      id: "a2", section: "Quantitative Reasoning",
      q: "A tuition of £20,000 rises by 5%. The new tuition is:",
      options: ["£20,500", "£21,000", "£25,000", "£22,000"], answer: 1,
    },
    {
      id: "a3", section: "Quantitative Reasoning",
      q: "If a scholarship covers 60% of a £15,000 cost, the remaining amount is:",
      options: ["£9,000", "£6,000", "£5,000", "£7,500"], answer: 1,
    },
    {
      id: "a4", section: "Logical Reasoning",
      q: "Complete the sequence: 2, 6, 12, 20, ?",
      options: ["28", "30", "26", "32"], answer: 1,
    },
    {
      id: "a5", section: "Reading Comprehension",
      q: "An author 'concedes a limitation'. The author:",
      options: ["denies a weakness", "acknowledges a weakness", "hides a weakness", "ignores it"], answer: 1,
    },
    {
      id: "a6", section: "Academic Knowledge",
      q: "A 'literature review' primarily aims to:",
      options: ["report new experiments", "summarise existing research", "list references only", "present raw data"], answer: 1,
    },
    {
      id: "a7", section: "Quantitative Reasoning",
      q: "Exchange: £1 = Rp 19,600. £500 equals approximately:",
      options: ["Rp 9.8 juta", "Rp 8 juta", "Rp 19.6 juta", "Rp 5 juta"], answer: 0,
    },
    {
      id: "a8", section: "Logical Reasoning",
      q: "If submitting the SOP requires a finished shortlist, and the shortlist isn't done, then the SOP:",
      options: ["can be submitted", "cannot yet be submitted", "is optional", "is already done"], answer: 1,
    },
  ],
  scholarship: [
    {
      id: "s1", section: "Motivation",
      q: "The strongest motivation statement connects your goals to:",
      options: ["fame", "specific impact & contribution", "salary only", "travel"], answer: 1,
    },
    {
      id: "s2", section: "Leadership",
      q: "Best evidence of leadership in an application is:",
      options: ["a job title", "a concrete initiative you drove and its outcome", "hobbies", "high GPA alone"], answer: 1,
    },
    {
      id: "s3", section: "Study Goals",
      q: "A clear study goal statement should be:",
      options: ["vague and broad", "specific, relevant, time-bound", "unrelated to career", "about the country's weather"], answer: 1,
    },
    {
      id: "s4", section: "Situational Judgement",
      q: "You realise a deadline conflicts with an exam. The best first action:",
      options: ["ignore it", "plan a timeline and prioritise the largest gap early", "give up", "submit incomplete"], answer: 1,
    },
    {
      id: "s5", section: "Motivation",
      q: "Reviewers value motivation that is:",
      options: ["generic", "authentic and evidence-backed", "exaggerated", "copied"], answer: 1,
    },
    {
      id: "s6", section: "Leadership",
      q: "A good leadership reflection includes:",
      options: ["only successes", "challenges, actions, and lessons learned", "blaming others", "no detail"], answer: 1,
    },
  ],
};

export const targetScores = { english: 80, academic: 75, scholarship: 78 };
